"use client"
import {
  createContext,
  useContext,
  useState,
  ReactNode,
  useRef,
} from "react"
import { SwiperRef } from "swiper/react"

type PopupData = {
  isOpen: boolean
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  isOtherPopupOpen: boolean
  setisOtherPopupOpen: React.Dispatch<React.SetStateAction<boolean>>
  selectedImage: string | null
  selectedImageIndex: number
  images: { id: number; src: string; alt: string , type?: string , videoPoster?: string}[]
  openPopup: (
    images: PopupData["images"],
    selectedImage: string,
    index: number
  ) => void
  closePopup: () => void
  fullScreenSwiperRef: React.RefObject<SwiperRef | null>
  generalPlayVideo: boolean
  setGeneralPlayVideo: React.Dispatch<React.SetStateAction<boolean>>
  popupInnerData: any
  setPopupInnerData: React.Dispatch<React.SetStateAction<any>>
}

const defaultContext: PopupData = {
  isOpen: false,
  setIsOpen: () => {},
  isOtherPopupOpen: false,
  setisOtherPopupOpen: () => {},
  selectedImage: null,
  selectedImageIndex: 0,
  images: [],
  openPopup: () => {},
  closePopup: () => {},
  fullScreenSwiperRef: { current: null },
  generalPlayVideo: true,
  setGeneralPlayVideo: () => {},
  popupInnerData: null,
  setPopupInnerData: () => {}
}

export const PopupContext = createContext<PopupData>(defaultContext)

export const usePopupContext = () => useContext(PopupContext)

export const PopupProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [isOtherPopupOpen, setisOtherPopupOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null)
  const [selectedImageIndex, setSelectedImageIndex] = useState(0)
  const [images, setImages] = useState<PopupData["images"]>([])
  const [generalPlayVideo, setGeneralPlayVideo] = useState(true);
  const [popupInnerData, setPopupInnerData] = useState(null);

  const fullScreenSwiperRef = useRef<SwiperRef | null>(null)

  const openPopup = (
    images: PopupData["images"],
    src: string,
    index: number
  ) => {
    setImages(images)
    setSelectedImage(src)
    setSelectedImageIndex(index)
    setIsOpen(true)
    setGeneralPlayVideo(true)
  }

  const closePopup = () => {
    setIsOpen(false)
    setSelectedImage(null)
    setSelectedImageIndex(0)
    setImages([])
    setGeneralPlayVideo(false)
  }

  return (
    <PopupContext.Provider
      value={{
        isOpen,
        setIsOpen,
        isOtherPopupOpen,
        setisOtherPopupOpen,
        selectedImage,
        selectedImageIndex,
        images,
        openPopup,
        closePopup,
        fullScreenSwiperRef,
        generalPlayVideo,
        setGeneralPlayVideo,
        popupInnerData,
        setPopupInnerData
      }}
    >
      {children}
    </PopupContext.Provider>
  )
}
